/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Exercise_GoalInputs */

const en_us2_offline_kind_exercise_goal = /** @type {(inputs: Offline_Kind_Exercise_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise goal`)
};

const pt_br2_offline_kind_exercise_goal = /** @type {(inputs: Offline_Kind_Exercise_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta de exercício`)
};

const es_419_offline_kind_exercise_goal = /** @type {(inputs: Offline_Kind_Exercise_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta de ejercicio`)
};

const pt_pt2_offline_kind_exercise_goal = /** @type {(inputs: Offline_Kind_Exercise_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta de exercício`)
};

const fr_fr2_offline_kind_exercise_goal = /** @type {(inputs: Offline_Kind_Exercise_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif d'exercice`)
};

const de_de2_offline_kind_exercise_goal = /** @type {(inputs: Offline_Kind_Exercise_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungsziel`)
};

const it_it2_offline_kind_exercise_goal = /** @type {(inputs: Offline_Kind_Exercise_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo di esercizio`)
};

/**
* | output |
* | --- |
* | "Exercise goal" |
*
* @param {Offline_Kind_Exercise_GoalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_exercise_goal = /** @type {((inputs?: Offline_Kind_Exercise_GoalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Exercise_GoalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_exercise_goal(inputs)
	if (locale === "es-419") return es_419_offline_kind_exercise_goal(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_exercise_goal(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_exercise_goal(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_exercise_goal(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_exercise_goal(inputs)
	return en_us2_offline_kind_exercise_goal(inputs)
});
export { offline_kind_exercise_goal as "offline.kind_exercise_goal" }